import { deepClone } from "@/utils"
import set from "lodash.set"

export default {
	setProperty(state, { path, value }) {
		set(state, path, value)
	},

	/**
	 * @param {*} object
	 * id:   uniq identify of an event
	 * key:  determine events for 1 object
	 * type: determine type of an event
	 * data; data belong to that event
	 */
	addEvent(state, { id, groupId, type, data }) {
		state.events.push({ id, groupId, type, data })
	},

	/**
	 * @param {*} eventId : id of an event
	 */
	removeEvent(state, { eventId, error }) {
		const newEvents = deepClone(state.events)
		if (!error) {
			state.events = state.events.filter(e => e.id !== eventId)
			return
		}
		// All the event in the same group and happened after removed event will also removed in error case
		const eventToRemoveIdx = newEvents.findIndex(e => e.id === eventId)
		const eventsToRemove = newEvents
			.filter((e, idx) => e.groupId === newEvents[eventToRemoveIdx].groupId && idx >= eventToRemoveIdx)
			.map(e => e.id)
		state.events = newEvents.filter(e => !eventsToRemove.includes(e.id))
	},

	addProduct(state, newProduct) {
		state.list.unshift(newProduct)
	},

	setProduct(state, payload) {
		state.detail.product = payload
	},

	updateProduct(state, payload) {
		state.detail.product = { ...state.detail.product, ...payload }
	},

	setErrors(state, payload) {
		state.errors = payload
	},

	clearErrors(state) {
		state.errors = {}
	}
}
